<button mat-icon-button *ngIf="!!hilfe || hasCreateHelpPermission" (click)="openHilfeDialog()">
    <mat-icon>help_outline</mat-icon>
</button>
